import { Action } from '@ngrx/store';

import { Container } from '®shared/reading-list/models';

export enum ContainerActionTypes {
  CONTAINER_INITIALISED = '[Container] container initialised',
}

export interface ContainerPayload {
  container: Container;
}

export class ContainerInitialisedAction implements Action {
  readonly type = ContainerActionTypes.CONTAINER_INITIALISED;

  constructor(public payload: ContainerPayload) {}
}

export type ContainerActions = ContainerInitialisedAction;
